import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {ICandidateOrderListResponse} from '../interfaces/services';
import {ICandidateOrderItem} from '../interfaces/dtos';

export const getSalesmanCandidateOrderList = async (
  clientId: string,
  token: string,
): Promise<ICandidateOrderListResponse> => {
  const remoteURI = remote.getCandidateOrderListUri(clientId);

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as ICandidateOrderItem[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as ICandidateOrderListResponse;
};
